<template>
  <div class="flex items-baseline justify-between space-x-2">
    <div class="grow">
      <div class="flex items-center space-x-2">
        <span
          v-tooltip="deal?.business?.business_legal_name"
          class="legal-name truncate"
        >
          {{ deal?.business?.business_legal_name }}
        </span>
        <span
          class="max-w-26 cursor-pointer truncate rounded-sm border bg-white px-1 text-xs"
          @click.stop.prevent="copyToClipboard(String(deal?.id))"
        >
          {{ $t("DEALS.TRACKING.UUID") }}: {{ deal?.id }}
        </span>
      </div>
      <div class="space-x-2 text-sm text-gray-400">
        <template v-if="deal?.client?.name">
          <span>{{ deal.client.name }}</span>
          <span>•</span>
        </template>
        <lf-date :date="deal?.created_at ?? ''" />
      </div>
    </div>
    <div v-if="isSelected" class="self-center">
      <icon-base :icon="IconCheckmarkRoundBlue" width="16" height="16" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useClipboardWithMessage } from "@/hooks/clipboard";

import IconCheckmarkRoundBlue from "@/components/icons/IconCheckmarkRoundBlue.vue";
import IconBase from "@/components/ui/IconBase.vue";
import LfDate from "@/components/ui/LfDate.vue";

import type { IApplication } from "@/models/applications";

defineProps<{
  deal: IApplication | null | undefined;
  isSelected?: boolean;
}>();

const copyToClipboard = useClipboardWithMessage();
</script>
